export const Users = {
  nicholai: '100302176047337472',
  jacobsen: '806924362062102528',
  bigcupping: '477447510097526803',
  s1n1sta: '567361638802391041',
  jesper: '792680888994758666',
  don_domingo: '206159854392311808',
  alex: '357053292825542656',
} as const

export const IdsToUsers = Object.fromEntries(Object.entries(Users).map(([k, v]) => [v, k] as const))

export const Advent24Users: string[] = [
  Users.bigcupping,
  Users.nicholai,
  Users.jacobsen,
  Users.s1n1sta,
  Users.jesper,
  Users.don_domingo,
]
